<template>
	
	<div class="inner success">
		<div class="content-box small">
			<div class="container">
				<div class="icon">
					<simple-svg 
						:filepath="'images/SVG/Success.svg'"
						:height="'175px'"
						:width="'175px'"
					/>
				</div>
				<h1>{{$t('screening.success.headline')}}</h1>
				<p class="text">{{$t('screening.success.text')}}</p>
				<button class="purple">{{$t('screening.success.button')}}</button>
			</div>
		</div>
	</div>


</template>
<script>
	import {store} from '../../store/index';
    import Vue from 'vue';

    export default {



    }
</script>
<style></style>